<template>
	<div class="invoice-form-container">
		<!-- 遮罩层 -->
		<div class="loading-mask" v-if="loading">
			<div class="loading-content">
				<div class="loading-spinner"></div>
				<div class="loading-text">{{ loadingText }}</div>
			</div>
		</div>
		
		<div class="tipBox">
			<div class="flexBox name">
				<img src="../assets/img/admin/icon_4.png" class="icon">
				<div class="txt">{{ tipTitle }}：</div>
			</div>
			<div class="tip">{{ tipContent }}</div>
		</div>
		
		<div class="flexBox formList">
			<div class="infoBox" style="width: 75rem;">
				<div class="title">开票信息</div>
				<a-form-model class="formBox" :model="formData">
					<a-form-model-item label="发票抬头：" class="warn">
						<div class="company-search-container" ref="searchContainer">
							<a-input 
								v-model="formData.invoiceTitle" 
								placeholder="请输入发票抬头，按回车搜索"
								@pressEnter="handleCompanySearch"
								@click="handleInputClick"
								:loading="companyLoading"
								@focus="handleInputFocus"
							/>
							<!-- 企业搜索下拉框 -->
							<div v-if="companyList.length > 0" class="company-dropdown">
								<div 
									v-for="(company, index) in companyList" 
									:key="index"
									class="dropdown-item"
									@click="handleCompanySelect(company)"
								>
									<div class="company-name">{{ company.qymc }}</div>
									<div class="company-tax">税号：{{ company.qysh }}</div>
								</div>
							</div>
						</div>
					</a-form-model-item>
					<a-form-model-item label="纳税人识别码（税号）：" class="warn">
						<a-input v-model="formData.taxNumber" placeholder="请输入纳税人识别号" />
					</a-form-model-item>
					<a-form-model-item label="发票金额：" class="warn">
						<div class="flexBox">
							<a-input 
								v-model="formData.invoiceAmount" 
								placeholder="请输入发票金额" 
								:readonly="isAmountReadonly"
								:disabled="isAmountReadonly"
							/>
							<div class="limit">
								<span v-if="isAmountReadonly">换开金额不可修改</span>
								<span v-else-if="balance">您当前可开票金额总数为：{{balance.availableAmount}}元</span>
							</div>
						</div>
					</a-form-model-item>
					<a-form-model-item label="发票类型：" class="warn">
						<a-select v-model="formData.invoiceType" placeholder="请选择发票类型">
							<a-select-option :key="idx" :value="item.value" v-for="(item,idx) in typeList">
								{{item.label}}
							</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item label="电话：" class="warn" v-if="formData.invoiceType != '增值税电子普通发票'">
						<a-input v-model="formData.comPhone" placeholder="" />
					</a-form-model-item>
					<a-form-model-item label="地址：" class="warn" v-if="formData.invoiceType != '增值税电子普通发票'">
						<a-input v-model="formData.address" placeholder="" />
					</a-form-model-item>
					<a-form-model-item label="开户银行：" class="warn" v-if="formData.invoiceType != '增值税电子普通发票'">
						<a-input v-model="formData.bankName" placeholder="" />
					</a-form-model-item>
					<a-form-model-item label="银行账号：" class="warn" v-if="formData.invoiceType != '增值税电子普通发票'">
						<a-input v-model="formData.bankAccount" placeholder="" />
					</a-form-model-item>
				</a-form-model>
			</div>
			<div class="tellBox" style="width: 51rem;">
				<div class="title">联系信息</div>
				<a-form-model class="formBox" :model="formData">
					<a-form-model-item label="联系人：" class="warn">
						<a-input v-model="formData.contactPerson" placeholder="请输入联系人" />
					</a-form-model-item>
					<a-form-model-item label="手机号" class="warn">
						<a-input v-model="formData.contactPhone" placeholder="请输入联系人手机号" />
					</a-form-model-item>
					<a-form-model-item label="邮箱：">
						<a-input v-model="formData.contactEmail" placeholder="请输入邮箱" />
					</a-form-model-item>
					<a-form-model-item label="备注：">
						<a-input v-model="formData.remark" type="textarea" placeholder="" />
					</a-form-model-item>
					<a-button class="btn" @click="handleSubmit" :loading="loading" :disabled="loading">
						{{ submitButtonText }}
					</a-button>
				</a-form-model>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InvoiceForm',
	props: {
		// 表单数据
		value: {
			type: Object,
			default: () => ({
				invoiceType: "增值税电子专用发票"
			})
		},
		// 是否为换开模式（换开模式下金额不可编辑）
		isReissue: {
			type: Boolean,
			default: false
		},
		// 加载状态
		loading: {
			type: Boolean,
			default: false
		},
		// 加载文字
		loadingText: {
			type: String,
			default: '提交中，请稍候...'
		},
		// 提示标题
		tipTitle: {
			type: String,
			default: '发票说明'
		},
		// 提示内容
		tipContent: {
			type: String,
			default: '您好，请正确核对开票信息，提交后不可修改。'
		},
		// 提交按钮文字
		submitButtonText: {
			type: String,
			default: '发票申请'
		},
		// 余额信息（用于申请模式）
		balance: {
			type: Object,
			default: null
		},
		// 原始金额（用于换开模式验证）
		originalAmount: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			formData: {
				invoiceType: "增值税电子专用发票",
				...this.value
			},
			companyLoading: false,
			companyList: [],
			selectedCompany: null,
			typeList: [{
				label: "增值税电子专用发票",
				value: "增值税电子专用发票",
			}, {
				label: "增值税电子普通发票",
				value: "增值税电子普通发票",
			}]
		}
	},
	computed: {
		isAmountReadonly() {
			return this.isReissue;
		}
	},
	watch: {
		value: {
			handler(newVal) {
				this.formData = { ...newVal };
			},
			deep: true,
			immediate: true
		}
	},
	mounted() {
		// 初始化表单数据
		if (this.value) {
			this.formData = { ...this.formData, ...this.value };
		}
		// 添加全局点击事件监听
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		// 移除全局点击事件监听
		document.removeEventListener('click', this.handleClickOutside);
	},
	methods: {
		// 更新父组件数据
		updateParentData() {
			this.$emit('input', this.formData);
		},
		// 处理点击外部关闭下拉框
		handleClickOutside(event) {
			if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
				this.companyList = [];
			}
		},
		// 处理输入框获得焦点
		handleInputFocus() {
			// 如果之前有搜索结果，重新显示下拉框
			if (this.companyList.length > 0) {
				// 这里不需要做任何操作，因为v-if会自动显示
			}
		},
		// 处理输入框点击
		handleInputClick() {
			// 如果输入框有内容，点击时触发搜索
			if (this.formData.invoiceTitle && this.formData.invoiceTitle.trim() !== '') {
				this.handleCompanySearch();
			}
		},
		// 处理企业搜索（按回车触发）
		handleCompanySearch() {
			const searchValue = this.formData.invoiceTitle.trim();
			if (!searchValue) {
				this.$message.warning("请输入发票抬头");
				return;
			}
			
			this.companyLoading = true;
			this.companyList = []; // 清空之前的搜索结果
			this.selectedCompany = null; // 清空之前的选择
			
			this.$reqToken("post", "/api/center/invoice/getCompany", {
				comName: searchValue
			}).then((res) => {
				if (res.code === 200 && res.data && res.data.length > 0) {
					this.companyList = res.data;
					this.$message.success(`找到 ${res.data.length} 家企业，请从下拉框中选择`);
				} else {
					this.companyList = [];
					this.$message.info("未找到匹配的企业");
				}
			}).catch((error) => {
				console.error("企业搜索失败:", error);
				this.companyList = [];
				this.$message.error("搜索失败，请重试");
			}).finally(() => {
				this.companyLoading = false;
			});
		},
		// 处理企业选择
		handleCompanySelect(company) {
			this.selectedCompany = company;
			
			// 先清空之前的所有信息
			this.formData.taxNumber = '';
			this.formData.address = '';
			this.formData.comPhone = '';
			this.formData.bankName = '';
			this.formData.bankAccount = '';
			
			// 自动填充发票抬头（覆盖用户输入）
			this.formData.invoiceTitle = company.qymc;
			// 自动填充纳税人识别码
			this.formData.taxNumber = company.qysh;
			
			// 处理地址和电话（dzdh字段空格分割）
			if (company.dzdh) {
				const dzdh = company.dzdh.trim();
				const lastSpaceIndex = dzdh.lastIndexOf(' ');
				if (lastSpaceIndex > 0) {
					this.formData.address = dzdh.substring(0, lastSpaceIndex).trim();
					this.formData.comPhone = dzdh.substring(lastSpaceIndex + 1).trim();
				} else {
					this.formData.address = dzdh;
					this.formData.comPhone = '';
				}
			}
			
			// 处理开户银行和银行账号（yhzh字段空格分割）
			if (company.yhzh) {
				const yhzh = company.yhzh.trim();
				const lastSpaceIndex = yhzh.lastIndexOf(' ');
				if (lastSpaceIndex > 0) {
					this.formData.bankName = yhzh.substring(0, lastSpaceIndex).trim();
					this.formData.bankAccount = yhzh.substring(lastSpaceIndex + 1).trim();
				} else {
					this.formData.bankName = yhzh;
					this.formData.bankAccount = '';
				}
			}
			
			// 选择后隐藏下拉框
			this.companyList = [];
			
			// 更新父组件数据
			this.updateParentData();
			
			this.$message.success(`已选择企业：${company.qymc}`);
		},
		// 表单验证
		validateForm() {
			if (!this.formData.invoiceTitle || this.formData.invoiceTitle === "") {
				this.$message.error("请输入发票抬头！");
				return false;
			}
			
			if (!this.formData.taxNumber || this.formData.taxNumber === "" || !/^[0-9A-HJ-NP-RT-Z]{18}$/.test(this.formData.taxNumber)) {
				this.$message.error("纳税人识别码有误");
				return false;
			}

			if (!this.formData.invoiceAmount || this.formData.invoiceAmount === "") {
				this.$message.error("请输入发票金额！");
				return false;
			}

			if (this.formData.invoiceAmount <= 0) {
				this.$message.error("开票金额必须大于0");
				return false;
			}

			// 换开模式下验证金额是否被修改
			if (this.isReissue && this.formData.invoiceAmount !== this.originalAmount) {
				this.$message.error("换开金额不能修改！");
				// 强制恢复原始金额
				this.formData.invoiceAmount = this.originalAmount;
				return false;
			}

			// 申请模式下验证可开票余额
			if (!this.isReissue && this.balance && this.formData.invoiceAmount > this.balance.availableAmount) {
				this.$message.error("发票金额不能大于可开票金额总数");
				return false;
			}

			if (!this.formData.invoiceType || this.formData.invoiceType === "") {
				this.$message.error("请选择发票类型！");
				return false;
			}
			
			if (this.formData.invoiceType == "增值税电子专用发票") {
				if (!this.formData.comPhone || this.formData.comPhone === "") {
					this.$message.error("请输入开票电话信息！");
					return false;
				}
				
				// 验证开户银行电话格式
				const phoneRegex = /^(\d{3,4}-\d{7,8}|\d{7,8}|1[3-9]\d{9})$/;
				if (!phoneRegex.test(this.formData.comPhone.trim())) {
					this.$message.error("公司电话格式不正确，请输入正确的电话号码");
					return false;
				}
				
				if (!this.formData.address || this.formData.address === "") {
					this.$message.error("请输入开票地址信息！");
					return false;
				}
				
				if (!this.formData.bankName || this.formData.bankName === "") {
					this.$message.error("请输入开户银行！");
					return false;
				}
				
				if (!this.formData.bankAccount || this.formData.bankAccount === "") {
					this.$message.error("请输入银行账号！");
					return false;
				}

				// 验证银行账号格式
				const bankAccountRegex = /^\d{16,20}$/;
				if (!bankAccountRegex.test(this.formData.bankAccount.replace(/\s/g, ''))) {
					this.$message.error("银行账号格式不正确，请输入16-20位数字");
					return false;
				}
			}

			if (!this.formData.contactPerson || this.formData.contactPerson === "") {
				this.$message.error("请添加联系人！");
				return false;
			}

			if (!/^1[3456789]\d{9}$/.test(this.formData.contactPhone)) {
				this.$message.error("手机号有误");
				return false;
			}

			return true;
		},
		// 处理提交
		handleSubmit() {
			if (this.loading) {
				return;
			}
			
			if (!this.validateForm()) {
				return;
			}
			
			// 处理增值税电子普通发票的特殊逻辑
			if (this.formData.invoiceType == "增值税电子普通发票") {
				this.formData.comPhone = "";
				this.formData.address = "";
				this.formData.bankName = "";
				this.formData.bankAccount = "";
			}
			
			this.$emit('submit', this.formData);
		}
	}
}
</script>

<style scoped>
/* 遮罩层样式 */
.loading-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
}

.loading-content {
	background: white;
	padding: 2rem;
	border-radius: 8px;
	text-align: center;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.loading-spinner {
	width: 40px;
	height: 40px;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #1890ff;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin: 0 auto 1rem;
}

.loading-text {
	color: #666;
	font-size: 14px;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

/* 金额字段只读样式 */
.infoBox .formBox .flexBox .ant-input[readonly] {
	background-color: #f5f5f5 !important;
	color: #666 !important;
	cursor: not-allowed !important;
	border-color: #d9d9d9 !important;
}

.infoBox .formBox .flexBox .ant-input[disabled] {
	background-color: #f5f5f5 !important;
	color: #666 !important;
	cursor: not-allowed !important;
	border-color: #d9d9d9 !important;
}

/* 企业搜索容器样式 */
.company-search-container {
	position: relative;
}

/* 隐藏的下拉选择框样式 */
.company-dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background: white;
	border: 1px solid #d9d9d9;
	border-top: none;
	border-radius: 0 0 4px 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	max-height: 200px;
	overflow-y: auto;
}

.dropdown-title {
	padding: 8px 12px;
	background: #f5f5f5;
	border-bottom: 1px solid #d9d9d9;
	font-size: 14px;
	color: #666;
	font-weight: 500;
}

.dropdown-item {
	padding: 10px 12px;
	cursor: pointer;
	border-bottom: 1px solid #f0f0f0;
	transition: background-color 0.2s;
}

.dropdown-item:last-child {
	border-bottom: none;
}

.dropdown-item:hover {
	background-color: #f0f7ff;
}

.company-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-bottom: 4px;
}

.company-tax {
	font-size: 12px;
	color: #666;
}
</style>